import React from 'react';
import { Dialogs, PortalOverlay, Content, Button, Pane, Text } from '@leverege/ui-elements';
import { TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import DesktopSearchBar from "./DesktopSearchBar.js";
import S from './MobileSearchBar.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.screens.group.SearchBar');
export default function MobileSearchBar(props) {
  const {
    objectType,
    relationship: {
      path,
      blueprint
    },
    variant = 'mobileSearch|search',
    toolbarVariant = 'mobileActionBar|actionBar',
    actionBarMatchContext = {
      use: 'actionBar',
      client: 'molten.groupMobile.SearchBar',
      objectType,
      path
    },
    areaVariant = 'mobileSearchArea|searchArea',
    headerVariant = 'mobileSearchHeader|searchHeader',
    animation = Config.get('MobileSearch', 'animation', 'fade'),
    suggestionsVariant = 'mobileSuggestions|suggestions',
    onFilterChange
  } = props;
  const openDialog = () => {
    Dialogs.show({
      id: 'search',
      component: MobileSearchDialog,
      props: {
        onFilterChange,
        animation,
        blueprint,
        toolbarVariant,
        variant,
        areaVariant,
        headerVariant,
        suggestionsVariant,
        actionBarMatchContext,
        ...props
      }
    });
  };
  return /*#__PURE__*/_jsx(DesktopSearchBar, {
    ...props,
    onFocus: openDialog,
    variant: variant,
    suggestionsVariant: suggestionsVariant,
    suggestionsEnabled: false,
    actionBarMatchContext: actionBarMatchContext
  });
}
function MobileSearchDialog(props) {
  const {
    show,
    onClose,
    onFilterChange,
    animation,
    blueprint,
    toolbarVariant,
    variant,
    areaVariant,
    headerVariant,
    suggestionsVariant,
    actionBarMatchContext
  } = props;
  const closeAndChange = (...args) => {
    onFilterChange(...args);
    onClose();
  };
  return /*#__PURE__*/_jsx(PortalOverlay, {
    animation: animation,
    position: "center",
    show: show,
    escapeWillClose: false,
    clickWillClose: false,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Content, {
      variant: "mobileSearchDialog",
      className: S.container,
      relative: true,
      children: [/*#__PURE__*/_jsx(Content.Header, {
        children: /*#__PURE__*/_jsx(TitleBar, {
          variant: "mobileSearchDialogHeader|dialogHeader",
          title: /*#__PURE__*/_jsxs(Pane, {
            layout: "flex:rowMCenter|rowM",
            children: [/*#__PURE__*/_jsx(Button, {
              variant: "mobileActionBar",
              icon: tIcon('icon', 'fa fa-angle-left'),
              onClick: onClose
            }), /*#__PURE__*/_jsx(Text, {
              variant: "mobileSearchDialogHeader|dialogHeader",
              children: t('search', {
                blueprintName: blueprint?.namePlural
              })
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Content.Area, {
        variant: "mobileSearchDialogArea",
        children: /*#__PURE__*/_jsx(DesktopSearchBar, {
          ...props,
          focusOnMount: true,
          renderAs: "list",
          onFilterChange: closeAndChange,
          toolbarVariant: toolbarVariant,
          variant: variant,
          areaVariant: areaVariant,
          headerVariant: headerVariant,
          suggestionsVariant: suggestionsVariant,
          actionBarMatchContext: actionBarMatchContext,
          showSuggestionHelp: true
        })
      })]
    })
  });
}